import type { Hourly } from '../hourlyType';
import type { Exclusion } from './exclusion.type';

interface Users {
  defaultShop: string;
  isActive: boolean;
  role: string;
  userPrincipalName?: string;
  username?: string;
  color: string;
}

export interface FloristInfo {
  floristId: string;
  personalCode: string;
  unitCountryCode?: string;
  phone: string;
  email: string | null;
  deliveryServiceProviders: {
    companyName: string;
    displayPrice: boolean;
    noticePeriod: number;
    slotList: [
      {
        start: Date;
        end: Date;
      },
    ];
    deliverySlotType: string;
  }[];
  secondEmail?: string;
  businessContactName?: string | null;
  businessContactEmail?: string | null;
  businessContactPhone?: string | null;
  ownerName?: string | null;
  shopContactName?: string | null;
  shopAddress?: string | null;
  floristActivity: {
    agreementOn: Date;
    lastSuspensionReason: string;
    lastSuspensionOn: string;
    lastReinstateOn: string;
    blockedInExecution?: boolean;
    blockedInTransmission?: boolean;
    deleted?: boolean;
    suspended?: boolean;
  };
  userActivity: {
    createdBy: string;
    createdAt: Date;
    lastModifiedBy: string;
    lastModified: Date;
  };
  shopLocation: {
    name: string;
    street: string;
    zipCode: string;
    city: string;
    countryCode: string;
    latitude: number;
    longitude: number;
  };
  accessories: [
    {
      productCode: string;
      productName: string;
      isInStock: boolean;
    },
  ];
  calendar: Array<Hourly>;
  documents: [
    {
      docType: string;
      url: string;
      year: number;
      month: number;
    },
  ];
  users: Array<Users>;
  specialDays: {
    start: string;
    end: string;
    type: string;
  }[];
  nonDeliveredPlaces: Exclusion[];
  isXL: boolean;
  xlAssortments: {
    assignedAt: string;
    assignedBy: string;
    disabledProducts: { productId: string; productKey: string }[];
    productSelectionId: string;
    productSelectionKey: string;
  }[];
  additionalDeliveredPlaces: {
    id: string;
    zipCode: string;
    city: string;
    countryCode: string;
    isXlOnly: boolean;
  }[];
  deliveryRadius: {
    floristId: string;
    minAllowedRadiusInMeter: number;
    maxAllowedRadiusInMeter: number;
    deliveryRadiuses: {
      radius: number;
      isXlOnly: boolean;
    }[];
  };
}

export const emptyFloristInfo: FloristInfo = {
  floristId: '',
  personalCode: '',
  unitCountryCode: '',
  phone: '',
  email: null,
  secondEmail: '',
  businessContactName: null,
  businessContactEmail: null,
  businessContactPhone: null,
  ownerName: null,
  shopContactName: null,
  shopAddress: null,
  deliveryServiceProviders: [],
  floristActivity: {
    agreementOn: new Date(),
    lastSuspensionReason: '',
    lastSuspensionOn: '',
    lastReinstateOn: '',
    blockedInExecution: false,
    blockedInTransmission: false,
    deleted: false,
    suspended: false,
  },
  userActivity: {
    createdBy: '',
    createdAt: new Date(),
    lastModifiedBy: '',
    lastModified: new Date(),
  },
  shopLocation: {
    name: '',
    street: '',
    zipCode: '',
    city: '',
    countryCode: '',
    latitude: 0,
    longitude: 0,
  },
  accessories: [
    {
      productCode: '',
      productName: '',
      isInStock: false,
    },
  ],
  calendar: [],
  documents: [
    {
      docType: '',
      url: '',
      year: 0,
      month: 0,
    },
  ],
  users: [
    {
      defaultShop: '',
      isActive: false,
      role: '',
      userPrincipalName: '',
      color: '',
    },
  ],
  specialDays: [
    {
      start: '',
      end: '',
      type: '',
    },
  ],
  nonDeliveredPlaces: [
    {
      id: '',
      zipCode: '',
      city: '',
      countryCode: '',
    },
  ],
  isXL: false,
  xlAssortments: [],
  additionalDeliveredPlaces: [],
  deliveryRadius: {
    floristId: '',
    minAllowedRadiusInMeter: 0,
    maxAllowedRadiusInMeter: 0,
    deliveryRadiuses: [],
  },
};
